import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/document.svg` */
export const DocumentIcon = createTripletGlyphIcon('DocumentIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.4504 9.00635C11.7539 9.00655 12.0001 9.25269 12.0002 9.55615C12.0002 9.85978 11.754 10.1067 11.4504 10.1069H6.39966C6.0959 10.1069 5.84985 9.85991 5.84985 9.55615C5.85005 9.25256 6.09602 9.00635 6.39966 9.00635H11.4504Z"
        fill="currentColor"
      />
      <path
        d="M11.4504 7.00049C11.754 7.00069 12.0002 7.24666 12.0002 7.55029C12.0001 7.85379 11.7539 8.09989 11.4504 8.1001H6.39966C6.096 8.1001 5.85001 7.85391 5.84985 7.55029C5.84985 7.24654 6.0959 7.00049 6.39966 7.00049H11.4504Z"
        fill="currentColor"
      />
      <path
        d="M11.4504 4.99365C11.754 4.99386 12.0002 5.23983 12.0002 5.54346C12.0002 5.84703 11.754 6.09306 11.4504 6.09326H7.35474C7.05102 6.09326 6.80403 5.84715 6.80396 5.54346C6.80396 5.2397 7.05098 4.99365 7.35474 4.99365H11.4504Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.679 1.22021C13.535 1.22021 14.2288 1.91398 14.2288 2.77002V13.2329C14.2287 14.0889 13.5349 14.7827 12.679 14.7827L3.31274 14.7837C2.45671 14.7837 1.76294 14.0889 1.76294 13.2329V5.25928C1.76294 4.40324 2.45671 3.70948 3.31274 3.70947H3.74536V2.77002C3.74536 1.9141 4.43929 1.2204 5.29517 1.22021H12.679ZM3.31274 4.80908C3.06423 4.80909 2.86255 5.01076 2.86255 5.25928V13.2329C2.86255 13.4814 3.06423 13.6831 3.31274 13.6831H3.71802V4.80908H3.31274ZM5.29517 2.31982C5.0468 2.32001 4.84497 2.52161 4.84497 2.77002V13.6831H12.679C12.9274 13.6831 13.1291 13.4814 13.1292 13.2329V2.77002C13.1292 2.52149 12.9275 2.31982 12.679 2.31982H5.29517Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.9504 10.1329C13.254 10.1331 13.5002 10.3791 13.5002 10.6827C13.5001 10.9862 13.2539 11.2322 12.9504 11.2325H7.13013C6.82668 11.2322 6.58048 10.9861 6.58032 10.6827C6.58032 10.3791 6.82658 10.1331 7.13013 10.1329H12.9504Z"
        fill="currentColor"
      />
      <path
        d="M12.9504 7.87506C13.2539 7.8753 13.5001 8.12135 13.5002 8.42487C13.5002 8.72848 13.254 8.97443 12.9504 8.97467H7.13013C6.82658 8.97442 6.58032 8.72847 6.58032 8.42487C6.58043 8.12135 6.82664 7.87531 7.13013 7.87506H12.9504Z"
        fill="currentColor"
      />
      <path
        d="M12.9504 5.61725C13.254 5.61749 13.5002 5.86442 13.5002 6.16803C13.5 6.47142 13.2538 6.7176 12.9504 6.71783H8.20532C7.90172 6.71783 7.6548 6.47157 7.65454 6.16803C7.65454 5.86427 7.90157 5.61725 8.20532 5.61725H12.9504Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2639 1.44147C15.189 1.44147 15.9397 2.1912 15.9397 3.11627V14.8868C15.9397 15.8118 15.189 16.5616 14.2639 16.5616L3.72681 16.5626C2.80183 16.5626 2.05217 15.8127 2.052 14.8878V5.91705C2.052 4.99198 2.80173 4.24225 3.72681 4.24225H4.28247V3.11627C4.28247 2.19123 5.03225 1.44153 5.95728 1.44147H14.2639ZM3.72681 5.34186C3.40924 5.34186 3.15161 5.59949 3.15161 5.91705V14.8878C3.15178 15.2052 3.40934 15.463 3.72681 15.463H4.25122V5.34186H3.72681ZM5.95728 2.54108C5.63976 2.54114 5.38208 2.79875 5.38208 3.11627V15.462H14.2639C14.5815 15.462 14.8391 15.2043 14.8391 14.8868V3.11627C14.8391 2.79871 14.5815 2.54108 14.2639 2.54108H5.95728Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.2502 13.5096C17.6642 13.5097 18.0001 13.8456 18.0002 14.2596C18.0002 14.6737 17.6643 15.0094 17.2502 15.0096H9.52368C9.10964 15.0094 8.77368 14.6737 8.77368 14.2596C8.77381 13.8456 9.10972 13.5098 9.52368 13.5096H17.2502Z"
        fill="currentColor"
      />
      <path
        d="M17.2502 10.4998C17.6643 10.5 18.0001 10.8358 18.0002 11.2498C18.0002 11.6639 17.6643 11.9997 17.2502 11.9998H9.52368C9.10964 11.9996 8.77368 11.6639 8.77368 11.2498C8.77378 10.8358 9.1097 10.5 9.52368 10.4998H17.2502Z"
        fill="currentColor"
      />
      <path
        d="M17.2502 7.49005C17.6643 7.49022 18.0002 7.82594 18.0002 8.24005C18.0002 8.65414 17.6643 8.98989 17.2502 8.99005H10.9563C10.5422 8.98998 10.2063 8.6542 10.2063 8.24005C10.2063 7.82588 10.5421 7.49012 10.9563 7.49005H17.2502Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.0188 1.90509C20.2614 1.90516 21.2688 2.91249 21.2688 4.15509V19.8494C21.2687 21.0919 20.2613 22.0994 19.0188 22.0994H4.96899C3.72635 22.0994 2.71899 21.0921 2.71899 19.8494V7.88849C2.71923 6.64604 3.7265 5.63849 4.96899 5.63849H5.69263V4.15509C5.69263 2.91262 6.70021 1.90536 7.94263 1.90509H19.0188ZM4.96899 7.13849C4.55492 7.13849 4.21922 7.47447 4.21899 7.88849V19.8494C4.21899 20.2636 4.55478 20.5994 4.96899 20.5994H5.65161V7.13849H4.96899ZM7.94263 3.40509C7.52864 3.40536 7.19263 3.74104 7.19263 4.15509V20.5994H19.0188C19.4329 20.5994 19.7687 20.2635 19.7688 19.8494V4.15509C19.7688 3.74092 19.433 3.40516 19.0188 3.40509H7.94263Z"
        fill="currentColor"
      />
    </svg>
  ),
});
